import { Selector } from '@ngxs/store';
import { NotificationsState, NotificationsStateModel } from './notifications.state';

export class NotificationsSelectors {
  @Selector([ NotificationsState ])
  static notifications(state: NotificationsStateModel) {
    return state.notifications;
  }

  @Selector([ NotificationsState ])
  static hasUnreadNotifications(state: NotificationsStateModel) {
    return state.hasUnreadNotifications;
  }
}
